import CustomModal from '../../../../components/Modal/CustomModal';
import { CustomTextField } from '../../../../components/CustomTextField';
import MarkAsCompletedModalApp from '../Functionality/MarkAsCompletedModalApp';
import CenterPhotoPicker from '../../../../components/PhotoPicker/SubComponent/CenterPhotoPicker';
import ContentPhotoPicker from '../../../../components/PhotoPicker/SubComponent/SingleFiles/ContentPhotoPicker';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import { size500KB } from '../../../../constant/variable';
import { SUGGESTION_MODE_OPTION } from '../../../../components/PhotoPicker/SubComponent/Models/Models';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const MarkAsCompletedModal = (props) => {
const {onHide, equipment, onCompleted, setMarkAsCompleted} = props;
    const {
        t,
        emptyFields,
        comment,
        setComment,
        photoPicker,
        setPhotoPicker,
        handleDelete,
        displayModal,
        setDisplayModal,
        handleComplete,
    } = MarkAsCompletedModalApp({equipment, onHide, setMarkAsCompleted, onCompleted});
    return (
        <CustomModal
            {...props}
            size='lg'
            title={t('mark_as_completed')}
            buttonConfirm='confirm'
            confirmButton={true}
            cancelButton={true}
            onConfirm={() => {
                handleComplete();
            }}
            classNameBody='m-0 p-0'
            display={displayModal}
        >
            <div className='row'>
                <div className='d-flex flex-column text-center mt-3'>
                    <span className='ibl-font-w-400 font-color-general-950 mx-1'>
                        {t('are_you_sure_you_want_to_mark_this_as_completed')}
                    </span>

                    <span className='ibl-font-w-700 font-color-general-950 mx-1 mb-3 mt-3'>
                        {t('please_provide_the_required_information_below').toUpperCase()}
                    </span>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <CustomTextField
                            id='txt_macm_introduction'
                            length={512}
                            name='comment'
                            value={comment}
                            trans={'comment'}
                            type='text'
                            onChange={(e) => {
                                setComment(e.target.value);
                            }}
                            multiline={true}
                            required
                            emptyFields={emptyFields}
                        />
                    </div>
                </div>
                <div className='text-center mb-4'>
                    <span className='ibl-font-w-700 font-color-general-950 mx-1 mb-4'>
                        {t('attach_evidence').toUpperCase()}
                    </span>
                </div>
                <div className='row mb-4'>
                    <div className='col-12'>
                        <CenterPhotoPicker classWith={'w-100'}>
                            <ContentPhotoPicker
                                id='mark_as_completed_file'
                                photoPickerFile={photoPicker}
                                setPhotoPickerFile={setPhotoPicker}
                                required={true}
                                disabled={false}
                                showBtnCamera={true}
                                handleDelete={handleDelete}
                                validateFace={false}
                                showBtnDelete={true}
                                showPreview={false}
                                typeSuggestions={SUGGESTION_MODE_OPTION.MATERIAL_AND_EQUIPMENT}
                                emptyFields={emptyFields}
                                inModal={true}
                                accept={{ ...FILE_TYPE.FILES, size: size500KB }}
                                setDisplayModal={setDisplayModal}
                            />
                        </CenterPhotoPicker>
                    </div>
                </div>
            </div>
        </CustomModal>
    );
};

export default MarkAsCompletedModal;
